module.exports = __webpack_public_path__ + "static/media/img_familia.a7633da8.jpg";